import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuService } from 'src/app/Service/application-menu/menu.service';
import { menuModel } from 'src/app/ViewModel/ApplicationMenu.Model';
import { EditMenuComponent } from '../add/edit-menu/edit-menu.component';

@Component({
  selector: 'app-application-menu',
  templateUrl: './application-menu.component.html',
  styleUrls: ['./application-menu.component.css']
})
export class ApplicationMenuComponent implements OnInit {

  public responseData: menuModel[] = [];

  constructor(private menuService: MenuService, private dialog: MatDialog,) { }

  ngOnInit() {
    this.getMenuData();
  }

  getMenuData() {
    this.menuService.getApplicationMenulist().subscribe(data => {   
      this.responseData = [];
      data.forEach((value:any) => {
        if (value.parentMenuId == null) {
          let _menu: menuModel = value;
          _menu.subMenu = data.filter((x: { parentMenuId: number; }) => x.parentMenuId == _menu.menuId);
          this.responseData.push(_menu);
        }
      });
     this.responseData= this.responseData.sort(function(a:any, b:any) { return a.menuOrder - b.menuOrder});   
     this.responseData.forEach((val:any) =>val.subMenu.sort(function(a: { menuOrder: number; }, b: { menuOrder: number; }) { return a.menuOrder - b.menuOrder }));
    });
  }

  onClick_manageMenu(dataItem: menuModel, parentMenuId: number, isParentCall: boolean) {
    let menuData: menuModel;
    if (dataItem) {
      menuData = dataItem;
    }
    else {
      menuData = {
        displayName: "",
        icon: "",
        isActive: true,
        isAdminMenu: true,
        isProjectCodeRequired: true,
        menuId: null,
        menuOrder: null,
        parentMenuId: isParentCall ? null : parentMenuId,
        routeUrl: "",
        help_url:"",
        subMenu: null
      }
    }

    let dialogRef = this.dialog.open(EditMenuComponent, {
      panelClass: 'mat-dialog-secondary',
      data: menuData
    });

    dialogRef.afterClosed().subscribe(data => {
      this.getMenuData();
    });
  }

}